import React, { useState } from 'react';

interface HealthConditionsStepProps {
  data?: any;
  onChange: (data: any) => void;
  onNext: (data: any) => void;
  onBack: () => void;
}

const HealthConditionsStep: React.FC<HealthConditionsStepProps> = ({ data, onChange, onNext, onBack }) => {
  const [formData, setFormData] = useState({
    condition_names: data?.condition_names || [],
    other_condition_text: data?.other_condition_text || '',
    allergies: data?.allergies || [],
    other_allergy_text: data?.other_allergy_text || '',
  });

  const commonConditions = [
    'Diabetes', 'Hypertension', 'Heart Disease', 'Asthma', 'Arthritis',
    'Obesity', 'High Cholesterol', 'Thyroid Disorders', 'Anemia', 'Kidney Disease'
  ];

  const commonAllergies = [
    'Peanuts', 'Tree Nuts', 'Shellfish', 'Fish', 'Eggs', 'Milk', 'Soy', 'Wheat',
    'Dairy', 'Gluten', 'Lactose', 'Sesame'
  ];

  const handleConditionToggle = (condition: string) => {
    const updated = formData.condition_names.includes(condition)
      ? formData.condition_names.filter((c: string) => c !== condition)
      : [...formData.condition_names, condition];
    const newData = { ...formData, condition_names: updated };
    setFormData(newData);
    onChange(newData);
  };

  const handleAllergyToggle = (allergy: string) => {
    const updated = formData.allergies.includes(allergy)
      ? formData.allergies.filter((a: string) => a !== allergy)
      : [...formData.allergies, allergy];
    const newData = { ...formData, allergies: updated };
    setFormData(newData);
    onChange(newData);
  };

  return (
    <div>
      <div className="form-group">
        <h2 className="form-section-title">Health Conditions</h2>
        <div className="two-column-list">
          {commonConditions.map((condition) => (
            <label key={condition} className="two-column-item">
              <input
                type="checkbox"
                className="form-checkbox"
                checked={formData.condition_names.includes(condition)}
                onChange={() => handleConditionToggle(condition)}
              />
              <span>{condition}</span>
            </label>
          ))}
        </div>
      </div>

      <div className="form-group">
        <label className="form-label">Other Conditions</label>
        <textarea
          className="form-textarea form-textarea-single-line"
          rows={1}
          value={formData.other_condition_text}
          onChange={(e) => {
            const newData = { ...formData, other_condition_text: e.target.value };
            setFormData(newData);
            onChange(newData);
          }}
          placeholder="List any other health conditions..."
        />
      </div>

      <div className="form-group">
        <h2 className="form-section-title">Allergies</h2>
        <div className="two-column-list">
          {commonAllergies.map((allergy) => (
            <label key={allergy} className="two-column-item">
              <input
                type="checkbox"
                className="form-checkbox"
                checked={formData.allergies.includes(allergy)}
                onChange={() => handleAllergyToggle(allergy)}
              />
              <span>{allergy}</span>
            </label>
          ))}
        </div>
      </div>

      <div className="form-group">
        <label className="form-label">Other Allergies</label>
        <textarea
          className="form-textarea form-textarea-single-line"
          rows={1}
          value={formData.other_allergy_text}
          onChange={(e) => {
            const newData = { ...formData, other_allergy_text: e.target.value };
            setFormData(newData);
            onChange(newData);
          }}
          placeholder="List any other allergies..."
        />
      </div>
    </div>
  );
};

export default HealthConditionsStep;
